export class GMaps {
  Device_ID: string;
  Column_Name: string;
  Operator: string;
  Value: string;
  AndOr: string;

  constructor() {
    this.Device_ID = "";
    this.Column_Name = "";
    this.Operator = "";
    this.Value = "";
    this.AndOr = "";
  }

}
